globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.ScrollToAnchor = (function() {
  function ScrollToAnchor() {}

  ScrollToAnchor.init = function() {
    try {
      var $target = $(window.location.hash);

      if($target.length) {
        $(window).on("load", function() {
          setTimeout(function() {
            ScrollToAnchor.scrollTo($target);
          }, 150);
        })
      }
    } catch(e) {
      console.error(e);
    }

  }

  ScrollToAnchor.scrollTo = function($target) {
    var offset = $target.offset().top;
    var $body = $("body");
    var $menu = $body.find("#menu");
    var $topbar = $body.find("#top-bar-inner");
    var fixedTopBar = $body.hasClass("top_bar_fixed");
    var fixedMenu = $body.hasClass("menu_fixed");

    if($menu.length && fixedMenu && !$menu.find('.menu-vertical').length) {
      offset -= $menu.outerHeight();
    }

    if ($topbar.length && fixedTopBar) {
      offset -= $topbar.outerHeight();
    }

    window.scrollTo(0, offset);
  }

  return ScrollToAnchor;
})();
